import React from 'react';
import { Icon } from '../checkout/icons';

interface ProductImagePlaceholderProps {
  size?: number;
  className?: string;
}

/**
 * Unified image placeholder for products without images.
 * Uses the whitelabel Icon system for visual consistency.
 */
const ProductImagePlaceholder: React.FC<ProductImagePlaceholderProps> = ({
  size = 48,
  className = '',
}) => {
  return (
    <div
      className={`w-full h-full flex items-center justify-center text-text-light ${className}`}
      aria-hidden="true"
    >
      <Icon name="shopping-bag" size={size} />
    </div>
  );
};

export default ProductImagePlaceholder;
